import { PHONE_CODE } from 'src/app/core/const.variables';

export interface WhatsappPhoneSource {
  phoneNumber?: string | null;
  phone?: string | null;
  countryCode?: string | null;
  phoneCode?: string | null;
  country?: string | null;
}

const DEFAULT_COUNTRY_CODE = '44';

export function getWhatsappPhoneNumber(source: WhatsappPhoneSource): string | null {
  const rawPhone = String(source?.phoneNumber || source?.phone || '').trim();
  if (!rawPhone || rawPhone.toLowerCase().includes('[anonymous]')) {
    return null;
  }

  const phoneDigits = rawPhone.replace(/\D/g, '');
  if (!phoneDigits) {
    return null;
  }

  const countryCode = getCountryCode(source);
  const hasExplicitCountryCode = /^\s*(\+|00)/.test(rawPhone);
  const normalizedPhone = hasExplicitCountryCode || phoneDigits.startsWith(countryCode)
    ? phoneDigits.replace(/^00/, '')
    : `${countryCode}${phoneDigits}`;

  return normalizedPhone.length >= 8 && normalizedPhone.length <= 15
    ? normalizedPhone
    : null;
}

export function buildWhatsappUrl(phoneNumber: string, message: string): string {
  return `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message || '')}`;
}

function getCountryCode(source: WhatsappPhoneSource): string {
  const rawCountryCode = String(source?.countryCode || source?.phoneCode || '').trim();
  const countryCode = rawCountryCode.replace(/\D/g, '');
  if (countryCode) {
    return countryCode;
  }

  const country = String(source?.country || '').trim().toLowerCase();
  const matchedCountry = PHONE_CODE.find(item =>
    item.name.toLowerCase() === country || item.code.toLowerCase() === country
  );

  return (matchedCountry?.dial_code || DEFAULT_COUNTRY_CODE).replace(/\D/g, '');
}
